import Text from "ab-text";

type CartInfoShippingProps = {
  language: string;
}

const CartInfoShipping = ({
  language
}: CartInfoShippingProps) => {
  if (typeof language !== 'string') return null;

  const info = getInfoShipping(language.toLowerCase())

  return info && (
    <div className="info">
      <img src="/images/info.png" width={20} height={20} />
      <Text element="span" style={{ fontSize: 11, color: "#a79669", fontFamily: "GT Eesti", fontWeight: 300 }}>
        {info}
      </Text>
    </div>
  )
}

function getInfoShipping(language: string) {
  const warnings = [
    {
      fromDate: '2023-08-01',
      toDate: '2023-08-16',
      info: {
        es: 'Los tiempos de entrega habituales (entre 48h-72h) pueden verse afectados por fiestas locales y nacionales los días 4, 14 y 15 agosto.',
        en: 'The usual delivery times (between 48h-72h) may be affected by local and national holidays on August 4, 14 and 15.',
        de: 'The usual delivery times (between 48h-72h) may be affected by local and national holidays on August 4, 14 and 15.',
      }

    }
  ];

  const time = (date?: string) => (
    date ? new Date(date).getTime() : new Date().getTime()
  )

  const todayTime = time();

  const warning = warnings.find(({ fromDate, toDate }) => {
    const fromTime = time(fromDate);
    const toTime = time(toDate);

    return todayTime > fromTime && todayTime < toTime;
  })

  if (warning && isKey(warning.info, language)) {
    return warning.info[language];
  } else {
    return null;
  }
}

function isKey<T extends object>(x: T, k: PropertyKey): k is keyof T {
  return k in x;
}

export default CartInfoShipping;